
export default [
  {
    path: '/app/login',
    name: 'Login',
    component: () => import('@/view/app/Login')
  },
  {
    path: '/app/index',
    name: 'ParkIndex',
    component: () => import('@/view/app/Index')
  },
  {
    path: '/app/bill',
    name: 'BillReport',
    component: () => import('@/view/app/park/BillReport')
  },
  {
    path: '/app/device',
    name: 'Device',
    component: () => import('@/view/app/park/Device')
  },
  {
    path: '/app/mine',
    name: 'Mine',
    component: () => import('@/view/app/park/Mine')
  },
  {
    path: '/app/lane',
    name: 'ParkLane',
    component: () => import('@/view/app/park/child/Lane')
  },
  {
    path: '/app/input',
    name: 'ParkInput',
    component: () => import('@/view/app/park/Input')
  },
  {
    path: '/app/mine/presentPlate',
    name: 'PresentPlateList',
    component: () => import('@/view/app/mine/PresentPlateList')
  },
  {
    path: '/app/mine/fixedPlate',
    name: 'FixedPlateList',
    component: () => import('@/view/app/mine/FixedPlateList')
  },
  {
    path: '/app/mine/fixedPlateInfo',
    name: 'FixedPlateInfo',
    component: () => import('@/view/app/mine/plateInfo/FixedPlateInfo')
  },
  {
    path: '/app/mine/addFixedPlate',
    name: 'AddFixedPlate',
    component: () => import('@/view/app/mine/plateInfo/AddFixedPlate')
  },
  {
    path: '/app/mine/monthUpdate',
    name: 'MonthUpdate',
    component: () => import('@/view/app/mine/plateInfo/MonthUpdate')
  },
  {
    path: '/app/mine/monthCharge',
    name: 'MonthCharge',
    component: () => import('@/view/app/mine/plateInfo/MonthCharge')
  },
  {
    path: '/app/mine/storedValueUpdate',
    name: 'StoredValueUpdate',
    component: () => import('@/view/app/mine/plateInfo/StoredValueUpdate')
  },
  {
    path: '/app/mine/storedValueCharge',
    name: 'StoredValueCharge',
    component: () => import('@/view/app/mine/plateInfo/StoredValueCharge')
  },
  {
    path: '/app/mine/vipUpdate',
    name: 'VipUpdate',
    component: () => import('@/view/app/mine/plateInfo/VipUpdate')
  },
  {
    path: '/app/mine/vip2Update',
    name: 'Vip2Update',
    component: () => import('@/view/app/mine/plateInfo/Vip2Update')
  },
  {
    path: '/app/mine/innerUpdate',
    name: 'InnerUpdate',
    component: () => import('@/view/app/mine/plateInfo/InnerUpdate')
  },
  {
    path: '/app/mine/blackList',
    name: 'BlackList',
    component: () => import('@/view/app/mine/BlackList')
  },
  {
    path: '/app/mine/blackList/add',
    name: 'BlackList',
    component: () => import('@/view/app/mine/plateInfo/AddBlackList')
  },
  {
    path: '/app/mine/payRecordList',
    name: 'PayRecordList',
    component: () => import('@/view/app/mine/PayRecordList')
  },
  {
    path: '/app/mine/chargeTotal',
    name: 'ChargeTotal',
    component: () => import('@/view/app/mine/ChargeTotal')
  },
  {
    path: '/app/mine/openGateRecordList',
    name: 'OpenGateRecordList',
    component: () => import('@/view/app/mine/OpenGateRecordList')
  },
  {
    path: '/app/mine/rechargeRecordList',
    name: 'RechargeRecordList',
    component: () => import('@/view/app/mine/RechargeRecordList')
  },
  {
    path: '/app/mine/unPaidRecordList',
    name: 'UnPaidRecordList',
    component: () => import('@/view/app/mine/UnPaidRecordList')
  },
  {
    path: '/app/mine/rePassword',
    name: 'UnPaidRecordList',
    component: () => import('@/view/app/mine/plateInfo/RePassword')
  },

  {
    path: '/app/mine/businessList',
    name: 'business',
    component: () => import('@/view/app/mine/BusinessList')
  },
  {
    path: '/app/mine/businessList/add',
    name: 'businessAdd',
    component: () => import('@/view/app/mine/plateInfo/AddBusiness')
  },
  {
    path: '/app/mine/businessList/charge',
    name: 'businessAdd',
    component: () => import('@/view/app/mine/plateInfo/BusinessCharge')
  },

  {
    path: '/app/mine/couponList',
    name: 'coupon',
    component: () => import('@/view/app/mine/CouponList')
  },
  {
    path: '/app/mine/couponList/add',
    name: 'couponAdd',
    component: () => import('@/view/app/mine/plateInfo/AddCoupon')
  },
  {
    path: '/app/mine/couponList/qr',
    name: 'couponAdd',
    component: () => import('@/view/app/mine/plateInfo/CouponQr')
  },
  {
    path: '/app/mine/couponList/downLoad',
    name: 'couponAdd',
    component: () => import('@/view/app/mine/plateInfo/CouponDown')
  },
  {
    path: '/app/mine/couponUseList',
    name: 'CouponUseList',
    component: () => import('@/view/app/mine/CouponUseList')
  },
  {
    path: '/app/mine/businessRechargeList',
    name: 'BusinessRechargeList',
    component: () => import('@/view/app/mine/BusinessRechargeList')
  },
  {
    path: '/app/mine/userList',
    name: 'UserList',
    component: () => import('@/view/app/mine/UserList')
  },
  {
    path: '/app/mine/userList/add',
    name: 'UserListAdd',
    component: () => import('@/view/app/mine/plateInfo/AddUser')
  },
  {
    path: '/app/mine/vehicleOwnerList',
    name: 'VehicleOwnerList',
    component: () => import('@/view/app/mine/VehicleOwnerList')
  },
  {
    path: '/app/mine/parkSpace',
    name: 'ParkSpace',
    component: () => import('@/view/app/mine/plateInfo/ParkSpace')
  },
]



// WEBPACK FOOTER //
// ./src/router/app.js